<template>
  <div :class="['section-header', 'section-header--' + variant]">
    <div class="section-header__sub">
      <span v-if="num" class="section-header__subNum">{{ num }}</span>
      <span v-if="num" class="section-header__subSep">/</span>
      <span class="section-header__subTxt">{{ subtitle }}</span>
      <span class="section-header__subLine"></span>
    </div>
    <h2 class="section-header__title" :style="titleStyle">
      <template v-if="Array.isArray(title)">
        <div
          v-for="(t, i) in title"
          :key="i"
          :class="[
            'section-header__titleLine',
            t.color === 'purple' ? 'section-header__titleLine--purple' : 'section-header__titleLine--black'
          ]"
          v-html="t.text"
        ></div>
      </template>
      <template v-else>
        <div class="section-header__titleLine section-header__titleLine--black" v-html="title"></div>
      </template>
    </h2>
    <template v-if="Array.isArray(desc)">
      <p :style="descStyle" v-for="(d, i) in desc" :key="i" class="section-header__desc" v-html="d"></p>
    </template>
    <template v-else>
      <p :style="descStyle" class="section-header__desc" v-html="desc"></p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    descStyle: {
      type: Object,
      default: () => ({})
    },
    titleStyle: {
      type: Object,
      default: () => ({})
    },
    variant: {
      type: String,
      default: 'why'
    },
    num: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    title: {
      type: [String, Array],
      default: ''
    },
    desc: {
      type: [String, Array],
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.section-header {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;

  &__sub {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 24px;
  }

  &__subNum {
    font-size: 20px;
    line-height: 1;
    color: #6E7494;
    font-weight: 700;
  }

  &__subSep {
    font-size: 20px;
    line-height: 1;
    color: #6E7494;
    font-weight: 500;
  }

  &__subTxt {
    font-size: 20px;
    line-height: 1;
    color: #6E7494;
    font-weight: 600;
  }

  &__subLine {
    margin-left: 12px;
    display: inline-block;
    width: 80px;
    height: 1px;
    background: #C6C0DC;
    vertical-align: middle;
  }

  &__title {
    margin: 0;
    padding: 0;
  }

  &__titleLine {
    font-size: 60px;
    line-height: 1;
    font-weight: 800;

    &--black {
      color: #11101A;
    }

    &--purple {
      background: linear-gradient(270deg, #6B3AFF 0%, #8B18FF 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }

  &__desc {
    margin: 8px 0 0;
    font-size: 20px;
    line-height: 1.4;
    color: #2F2B3C;
    font-weight: 500;
  }
  &--process {
    .section-header__sub {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 20px;
      color: #6E7494;
      font-weight: 600;

      em {
        display: inline-block;
        width: 160px;
        height: 1px;
        background: #C6C0DC;
      }
    }

    .section-header__titleLine {
      font-size: 60px;
      line-height: 1;
    }

    .section-header__titleLine--purple {
      margin-left: 0;
    }
  }

    .section-header__title {
      display: block;
      margin-bottom: 22px;
    }

    .section-header__titleLine {
      display: block;
    }
  }

</style>
